/*
 * @Description
 * <p>
 *
 * @author lachezar.parvin
 * @author Gallagher Bassett IT
 * @author Copyright (c) 2020 Gallagher Bassett Services, Inc.
 *
 */

import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from 'app/shared/services/auth.service';
import { Constants } from 'app/shared/config/constants';
import { ReporterCustomAdapter } from '../lib';
import { Questionnaire } from '../models/questionnaire.model';

@Injectable({
  providedIn: 'root'
})
export class QuestionnairesService {
  readonly url = Constants.questionnairesServiceUrl;
  dateFormatter = new ReporterCustomAdapter();

  constructor(private http: HttpClient, private authService: AuthService) {}

  find(activeDate?: string, locationIds?: string, lineOfBusiness?: string, jurisdiction?: string): Observable<Questionnaire[]> {
    const today = new Date();
    const todaysDate = this.dateFormatter.toModel({
      year: today.getFullYear(),
      day: today.getDate(),
      month: today.getMonth() + 1
    });

    const params = new HttpParams()
      .append('master', `${ true }`)
      .append('activeDate', (activeDate !== '') ? activeDate : todaysDate)
      .append('locationIds', `${ locationIds }`)
      .append('lineOfBusiness', `${ lineOfBusiness ? lineOfBusiness : 'all' }`)
      .append('jurisdiction', `${ jurisdiction ? jurisdiction : 'all' }`);
    return this.http.get<Questionnaire[]>(this.url, { params });
  }
}
